import { render } from "./video-img.vue?vue&type=template&id=32049140&scoped=true"
import script from "./video-img.vue?vue&type=script&lang=js"
export * from "./video-img.vue?vue&type=script&lang=js"

import "./video-img.vue?vue&type=style&index=0&id=32049140&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32049140"]])

export default __exports__